import(/* webpackMode: "eager" */ "/var/www/appagent/src/app/(landing)/cookie/page.tsx");
